export default {
  "chooseLang": "اختر لغتك",
  "whatsOnMind": "ما الذي يدور في ذهنك؟",
  "bestFood": "أفضل أماكن الأكل قريبة",
  "orderOnline": "اطلب عبر الإنترنت",
  "dineout": "الخروج للطعام",
  "popularRestaurants": "المطاعم الشهيرة لطلب الطعام عبر الإنترنت قريبة من هنا",
  "sortBy": "ترتيب حسب",
  "showMore": "أظهر المزيد",
  "seeMore": "شاهد المزيد",
  "getApp": "احصل على تطبيق Waseeny الآن!",
  "bestOffers": "للحصول على أفضل العروض والخصومات المُصممة خصيصًا لك.",
  "privacy": "سياسة الخصوصية",
  "terms": "الشروط والأحكام",
  "contact": "اتصل بنا",
  "setLocation": "تحديد الموقع",
  "locationDetected": "تم تحديد الموقع",
  "locationError": "فشل تحديد الموقع",
  "detecting": "جاري التحديد",
  "searchPlaceholder": "البحث عن المطاعم والأطباق...",
  "food": "طعام",
  "orderFoodFromRestaurants": "اطلب الطعام من مطاعمك المفضلة.",
  "exploreNow": "استكشف الآن",
  "discoverFoodTitle": "اكتشف أشهى المأكولات اللذيذة عبر الإنترنت بالقرب منك",
  "discoverFoodText": "هل تشتهي شيئًا لذيذًا؟ اكتشف عالمًا من المأكولات الشهية في متناول يدك مع خدمة توصيل الطعام بالقرب مني! سواء كنت ترغب في تناول برجر شهي، أو سوشي طازج، أو طبق باستا مريح، فهناك الكثير من الخيارات لإشباع رغباتك. تتيح لك سهولة توصيل الطعام عبر الإنترنت بالقرب مني استكشاف المطاعم والمأكولات المختلفة دون مغادرة منزلك...",
  "allRightsReserved": "جميع الحقوق محفوظة.",
  "logout": "تسجيل الخروج",
  "min": "دقيقة",
  "loading": "جار التحميل...",
  "error": "خطأ",
  "enterSearchTerm": "الرجاء إدخال كلمة بحث",
  "welcomeBack": "مرحباً بعودتك!",
  "loginSubtitle": "سجل دخولك لمواصلة رحلتك مع الطعام",
  "emailLabel": "البريد الإلكتروني",
  "passwordLabel": "كلمة المرور",
  "emailPlaceholder": "أدخل بريدك الإلكتروني",
  "passwordPlaceholder": "أدخل كلمة المرور",
  "forgotPassword": "هل نسيت كلمة المرور؟",
  "loggingIn": "جارٍ تسجيل الدخول...",
  "continueWithGoogle": "المتابعة باستخدام جوجل",
  "dontHaveAccount": "ليس لديك حساب؟",
  "signUp": "سجل الآن",
  "searchFoodPlaceholder": "البحث عن المطاعم والطعام",
  "signIn": "تسجيل الدخول",
  "viewCart": "عرض السلة",
  "home": "الرئيسية",
  "cityName": "اسم المدينة",
  "delivery": "توصيل",
  "freeDeliveryPromo": "توصيل مجاني للطلب الأول",
  "minOrder": "الحد الأدنى للطلب",
  "change": "تغيير",
  "dineOutAvailable": "تناول الطعام في الخارج متاح",
  "reserveTableNow": "احجز طاولتك الآن",
  "callForReservations": "اتصل للحجز",
  "reserveTable": "حجز طاولة",
  "dealsForYou": "عروض لك",
  "extraOff": "خصم إضافي 0.50",
  "noCodeRequired": "لا يلزم رمز | فوق 5",
  "searchDishesPlaceholder": "البحث عن أطباق",
  "popular": "شائع",
  "mostOrdered": "الأكثر طلباً الآن",
  "itemInCart": "عنصر في السلة",
  "itemsInCart": "عناصر في السلة",
  "itemAdded": "تمت إضافة العنصر إلى السلة!",
  "failedToAdd": "فشل في إضافة العنصر. حاول مرة أخرى.",
  "cartEmpty": "سلة التسوق فارغة",
  "add": "إضافة",
  "selectDeliveryAddress": "اختر عنوان التوصيل",
  "savedAddressFound": "لديك عنوان محفوظ في هذا الموقع",
  "addNewAddress": "إضافة عنوان جديد",
  "addressType": "نوع العنوان",
  "homeType": "المنزل",
  "workType": "العمل",
  "otherType": "آخر",
  "addressPlaceholder": "أدخل عنوانك الكامل (مثلاً: رقم المنزل، اسم المبنى، الشارع، الحي)",
  "instructionsPlaceholder": "تعليمات التوصيل (اختياري - مثلاً: رن الجرس مرتين)",
  "confirmAddress": "تأكيد العنوان",
  "deliveryAddress": "عنوان التوصيل",
  "cityLabel": "المدينة",
  "minDelivery": "دقيقة للتوصيل",
  "changeUpper": "تغيير",
  "choosePaymentMethod": "اختر طريقة الدفع",
  "proceedToPay": "المتابعة للدفع",
  "billDetails": "تفاصيل الفاتورة",
  "subtotal": "المجموع الفرعي",
  "standardDelivery": "توصيل قياسي",
  "free": "مجاني",
  "serviceFee": "رسوم الخدمة",
  "offerApplied": "تم تطبيق العرض",
  "off": "خصم",
  "grandTotal": "المجموع الكلي",
  "searchingFor": "جارٍ البحث عن",
  "resultsFor": "نتائج لـ",
  "noMatchesFound": "لم يتم العثور على نتائج لـ",
  "backToHome": "العودة للرئيسية",
  "restaurants": "المطاعم",
  "freeDelivery": "توصيل مجاني",
  "products": "المنتجات",
  "itemsAddedToCart": "تمت إضافة العناصر",
  "deliveryIn": "التوصيل خلال",
  "orderSummary": "ملخص الطلب",
  "noItemsInCart": "لا توجد عناصر في السلة",
  "payByUpi": "الدفع عبر تطبيق UPI",
  "addNewUpi": "إضافة معرف UPI جديد",
  "upiSubtitle": "يجب أن يكون لديك معرف UPI مسجل",
  "creditDebitCard": "بطاقة الائتمان والخصم",
  "addNewCard": "إضافة بطاقة جديدة",
  "savePayCards": "حفظ والدفع عبر البطاقات",
  "morePaymentOptions": "المزيد من خيارات الدفع",
  "phonePeGPay": "PhonePe و G Pay والمزيد",
  "netBanking": "الخدمات المصرفية عبر الإنترنت",
  "selectBanks": "اختر من قائمة البنوك",
  "payOnDelivery": "الدفع عند الاستلام",
  "codTitle": "الدفع نقدًا عند الاستلام (نقدًا / UPI)",
  "payOnReceive": "ادفع عند استلام طعامك",
  "placingOrder": "جاري تقديم الطلب...",
  "waitConfirmOrder": "يرجى الانتظار بينما نؤكد طلبك.",
  "waitProcessPayment": "يرجى الانتظار بينما نعالج دفعتك عبر",
  "orderConfirmed": "تم تأكيد الطلب",
  "orderConfirmedMessage": "تم تأكيد طلبك بنجاح! نحن نقوم بمعالجته حاليًا وسنقدم تحديثات عن الحالة قريبًا.",
  "viewBookingDetails": "عرض تفاصيل الحجز",
  "exploreOtherMenu": "استكشاف قائمة أخرى",
  "cartEmptyAlert": "السلة فارغة. يرجى إضافة عناصر أولاً.",
  "resetPassword": "إعادة تعيين كلمة المرور",
  "verifyOtp": "التحقق من رمز OTP",
  "enterEmailReset": "أدخل بريدك الإلكتروني لإعادة تعيين كلمة المرور",
  "enterOtpMobile": "أدخل رمز OTP المرسल إلى هاتفك",
  "enterNewPassword": "أدخل كلمة المرور الجديدة",
  "passwordResetSubSuccess": "تمت إعادة تعيين كلمة المرور الخاصة بك",
  "sending": "جاري الإرسال...",
  "sendOtp": "إرسال رمز OTP",
  "enterOtpLabel": "أدخل رمز OTP",
  "verifying": "جاري التحقق...",
  "resendOtpIn": "إعادة إرسال رمز OTP خلال",
  "resendOtpBtn": "إعادة إرسال رمز OTP",
  "newPasswordPlaceholder": "أدخل كلمة مرور جديدة",
  "resetting": "جاري إعادة التعيين...",
  "passwordResetSuccessMsg": "تمت إعادة تعيين كلمة المرور بنجاح! يمكنك الآن تسجيل الدخول بكلمة المرور الجديدة.",
  "backToLogin": "العودة لتسجيل الدخول",
  "back": "رجوع",
  "passLengthError": "يجب أن تتكون كلمة المرور من 6 أحرف على الأقل",
  "passMatchError": "كلمات المرور غير متطابقة",
  "orderPlacedOn": "تم تقديم الطلب في",
  "more": "أكثر",
  "reorder": "إعادة الطلب",
  "preparing": "جاري التحضير",
  "ongoing": "جاري التوصيل",
  "delivered": "تم التوصيل",
  "orderPlacedSuccess": "تم تقديم طلبك بنجاح",
  "orderIdLabel": "رقم الطلب",
  "totalAmountLabel": "المبلغ الإجمالي",
  "statusLabel": "الحالة",
  "trackOrder": "تتبع الطلب",
  "redirectingToTracking": "سيتم تحويلك إلى التتبع خلال",
  "seconds": "ثوانٍ",
  "pleaseLogInToOrder": "يرجى تسجيل الدخول لتقديم طلبك",
  "loginRequiredForOrder": "يجب أن يكون لديك حساب لحفظ عنوان التوصيل الخاص بك وإتمام عملية الدفع بأمان.",
  "logInOrCreateAccount": "تسجيل الدخول أو إنشاء حساب",
  "secureCheckout": "الدفع الآمن",
  "safePayment": "دفع آمن",
  "help": "مساعدة",
  "account": "حساب",
  "paymentMethods": "طرق الدفع",
  "items": "العناصر",
  "total": "الإجمالي",
  "onlinePaymentStripe": "الدفع عبر الإنترنت (Stripe)",
  "cardSubtitle": "فيزا، ماستركارد، مايسترو",
  "giropaySubtitle": "الدفع مباشرة من حسابك المصرفي",
  "klarnaSubtitle": "ادفع الآن أو لاحقاً",
  "barzahlung": "الدفع عند الاستلام",
  "doorstepPayment": "الدفع عند باب المنزل",
  "selected": "محدد",
  "payNow": "ادفع الآن",
  "processingTitle": "جاري المعالجة...",
  "okayOrderLater": "حسناً، سأطلب لاحقاً",
  "restaurantClosed": "المطعم مغلق حالياً",
  "moreItems": "المزيد من العناصر",
  "cartConflictMessage": "سلة التسوق الخاصة بك تحتوي على عناصر من مطعم آخر. هل تريد إفراغ السلة وإضافة هذا العنصر؟",
  "adding": "جاري الإضافة",
  "toCart": "إلى السلة",
  "Call number not available": "رقم الاتصال غير متاح",
  "Restaurant phone number not available": "رقم هاتف المطعم غير متاح",
  ",": ",",
  "Rider phone number not available.": "رقم هاتف السائق غير متاح.",
  "enterEmailError": "يرجى إدخال بريدك الإلكتروني",
  "enterValidEmailError": "يرجى إدخال بريد إلكتروني صالح",
  "enterPasswordError": "يرجى إدخال كلمة المرور",
  "enterOtpError": "يرجى إدخال رمز التحقق",
  "enterNewPassError": "يرجى إدخال كلمة مرور جديدة",
  "enterEmailPlaceholder": "أدخل بريدك الإلكتروني",
  "newPassword": "كلمة المرور الجديدة",
  "confirmPasswordLabel": "تأكيد كلمة المرور",
  "confirmNewPasswordPlaceholder": "أكد كلمة المرور الجديدة",
  "Token not received from backend": "فشل تسجيل الدخول. يرجى المحاولة مرة أخرى.",
  "Invalid email or password": "البريد الإلكتروني أو كلمة المرور غير صحيحة",
  "Google login token missing. Please try clicking the Google button again.": "لم تكتمل عملية تسجيل الدخول عبر Google. يرجى النقر على زر Google مرة أخرى.",
  "Something went wrong with Google Login": "حدث خطأ أثناء تسجيل الدخول عبر Google",
  "getStarted": "تسجيل الدخول",
  "or": "or",
  "No contact number available at the moment.": "لا يتوفر رقم تواصل في الوقت الحالي.",
  "Reason for cancellation?": "ما سبب الإلغاء؟",
  "Order cancelled successfully": "تم إلغاء الطلب بنجاح",
  "Why are you requesting a refund?": "لماذا تطلب استرداد المبلغ؟",
  "session_id": "session_id",
  "Thank you for your rating!": "شكرًا لتقييمك!",
  "Failed to reorder items. Please try again.": "تعذرت إعادة طلب الأصناف. يرجى المحاولة مرة أخرى.",
  "reordering": "reordering",
  "Delivery address is missing. Please go back to checkout.": "عنوان التوصيل مفقود. يرجى العودة إلى صفحة الدفع.",
  "Failed to add address": "تعذرت إضافة العنوان",
  "Failed to delete address": "تعذر حذف العنوان",
  "Failed to select address": "تعذر اختيار العنوان",
  "Please enter a valid 6-digit OTP": "يرجى إدخال رمز تحقق صالح من 6 أرقام",
  "Account deletion request submitted. Our team will contact you for verification.": "تم تقديم طلب حذف الحساب. سيتواصل معك فريقنا للتحقق.",
  "Add money feature coming soon!": "ميزة إضافة الرصيد قادمة قريبًا!",
  "oftenOrderedWith": "غالبًا ما يُطلب مع",
  "completeMeal": "أكمل وجبتك",
  "loginRequired": "تسجيل الدخول مطلوب",
  "loginRequiredSub": "يرجى تسجيل الدخول للمتابعة.",
  "logInNow": "سجّل الدخول الآن",
  "cancel": "إلغاء",
  "q": "q",
  "-": "-",
  "recentSearches": "عمليات البحث الأخيرة",
  "clear": "مسح",
  "pureVeg": "نباتي بالكامل",
  "rating": "التقييم",
  "anyPrice": "أي سعر",
  "Please enter a valid amount": "يرجى إدخال مبلغ صالح",
  "Please enter your Bank User ID": "يرجى إدخال معرّف المستخدم البنكي",
  "Bank transaction failed. Please check your bank status.": "فشلت المعاملة البنكية. يرجى التحقق من حالة حسابك البنكي.",
  "canvas": "canvas",
  "2d": "2d",
  "link": "link",
  "locality": "locality",
  "administrative_area_level_2": "administrative_area_level_2",
  "administrative_area_level_1": "administrative_area_level_1",
  "country": "country",
  "postal_code": "postal_code",
  "route": "route",
  "sublocality_level_1": "sublocality_level_1",
  "sublocality": "sublocality",
  "street_number": "street_number",
  "Checkout": "إتمام الطلب",
  "Choose a saved address or add a new one": "اختر عنوانًا محفوظًا أو أضف عنوانًا جديدًا",
  "DEFAULT": "افتراضي",
  "Change Map Location": "تغيير موقع الخريطة",
  "Select Location on Map": "تحديد الموقع على الخريطة",
  "Selected Location:": "الموقع المحدد:",
  "House / Flat No.": "رقم المنزل / الشقة",
  "e.g. Flat 101": "مثال: شقة 101",
  "Street / Area": "الشارع / المنطقة",
  "e.g. Main Street": "مثال: الشارع الرئيسي",
  "Landmark (Optional)": "علامة مميزة (اختياري)",
  "e.g. Near Apollo Hospital": "مثال: بالقرب من مستشفى أبولو",
  "Save As": "حفظ باسم",
  "Saving...": "جاري الحفظ...",
  "Save Address": "حفظ العنوان",
  "Cancel": "إلغاء",
  "Available Offers & Coupons": "العروض والكوبونات المتاحة",
  "Loading offers...": "جاري تحميل العروض...",
  "APPLIED": "تم التطبيق",
  "APPLY": "تطبيق",
  "No coupons available right now.": "لا توجد كوبونات متاحة حاليًا.",
  "Item Total": "مجموع العناصر",
  "Delivery Fee": "رسوم التوصيل",
  "Platform Fee": "رسوم المنصة",
  "Tax": "الضريبة",
  "Packaging": "التعبئة والتغليف",
  "Small Cart Fee": "رسوم السلة الصغيرة",
  "Surge Fee": "رسوم زيادة الطلب",
  "Tip": "إكرامية",
  "Discount": "الخصم",
  "Please log in for order": "يرجى تسجيل الدخول لتقديم طلبك",
  "Remove item": "إزالة العنصر",
  "No Max Limit": "لا يوجد حد أقصى",
  "Up to": "حتى",
  "OFF": "خصم",
  "Special offer for you!": "عرض خاص لك!",
  "Apna Resto": "مطعمنا",
  "Please fill all mandatory fields and select a location on the map.": "يرجى ملء جميع الحقول الإلزامية وتحديد الموقع على الخريطة.",
  "Failed to save address. Please try again.": "فشل حفظ العنوان. يرجى المحاولة مرة أخرى.",
  "Near": "بالقرب من",
  "Select City": "تحديد المدينة",
  "Choose a city...": "اختر مدينة...",
  "Loading cities...": "جاري تحميل المدن...",
  "No cities available": "لا توجد مدن متاحة",
  "Address not specified": "العنوان غير محدد",
  "Order failed": "فشل الطلب",
  "Loading Payment details...": "جاري تحميل تفاصيل الدفع...",
  "100% Secure Transaction": "معاملة آمنة 100%",
  "Debit/Credit Card / KLARNA": "بطاقة الخصم/الائتمان / KLARNA",
  "Secure payment via Stripe": "دفع آمن عبر Stripe",
  "Select Payment Method": "اختر طريقة الدفع",
  "Order Tracking": "تتبع الطلب",
  "Help": "مساعدة",
  "No orders found.": "لم يتم العثور على طلبات.",
  "Rate your Experience": "قيم تجربتك",
  "Tell us more about the food and delivery...": "أخبرنا المزيد عن الطعام والتوصيل...",
  "Submitting...": "جاري التقديم...",
  "Submit Rating": "تقديم التقييم",
  "Request Item-Level Refund": "طلب استرداد الأموال للعناصر",
  "Select the items that had issues and provide details.": "حدد العناصر التي بها مشكلات وقدم التفاصيل.",
  "No specific items found. Full order refund will be requested.": "لم يتم العثور على عناصر محددة. سيتم طلب استرداد كامل الطلب.",
  "Additional Note / Reason": "ملاحظة إضافية / السبب",
  "Describe the issue in detail...": "صف المشكلة بالتفصيل...",
  "Evidence Images (Optional, Max 6)": "صور الإثبات (اختياري، بحد أقصى 6)",
  "Click to select photos": "انقر لتحديد الصور",
  "Supports PNG, JPG, JPEG (Max 6 files)": "يدعم PNG، JPG، JPEG (بحد أقصى 6 ملفات)",
  "Submit Refund": "تقديم طلب الاسترداد",
  "Rate Order": "تقييم الطلب",
  "Refund Request": "طلب استرداد",
  "cancelled": "تم الإلغاء",
  "Missing Item": "عنصر مفقود",
  "Quality Issue / Burnt": "مشكلة في الجودة / محروق",
  "Spill / Damaged": "انسكاب / تالف",
  "Wrong Item": "عنصر خاطئ",
  "Late Delivery": "توصيل متأخر",
  "Other": "آخر",
  "Please select at least one item or provide a note for the refund.": "يرجى تحديد عنصر واحد على الأقل أو تقديم ملاحظة للاسترداد.",
  "Refund request submitted successfully. Admin will review it shortly.": "تم تقديم طلب استرداد الأموال بنجاح. سيقوم المسؤول بمراجعته قريبًا.",
  "Refund request submitted successfully!": "تم تقديم طلب استرداد الأموال بنجاح!",
  "Refund request failed": "فشل طلب استرداد الأموال",
  "Maximum 6 images are allowed.": "يسمح بحد أقصى 6 صور.",
  "Profile": "الملف الشخصي",
  "Menu": "القائمة",
  "Call Rider": "الاتصال بالسائق",
  "Call Restaurant": "الاتصال بالمطعم",
  "Your food is being prepared fresh!": "يتم تحضير طعامك طازجاً!",
  "Paid Amount": "المبلغ المدفوع",
  "Hurray! You saved": "مرحى! لقد وفرت",
  "on this order": "في هذا الطلب",
  "Track": "تتبع",
  "Payment Method": "طريقة الدفع",
  "Payment Details": "تفاصيل الدفع",
  "On": "في",
  "at": "عند",
  "Cancel Order": "إلغاء الطلب",
  "Failed to request refund": "فشل طلب استرداد الأموال",
  "Re-request Refund": "إعادة طلب الاسترداد",
  "Report Problem / Request Refund": "الإبلاغ عن مشكلة / طلب استرداد",
  "Refund Request Pending Admin Approval": "طلب الاسترداد قيد الانتظار لموافقة المسؤول",
  "Refund Completed": "اكتمل استرداد الأموال",
  "orders": "الطلبات",
  "topBrandsIn": "أفضل الماركات في",
  "yourArea": "منطقتك",
  "filters": "الفلاتر",
  "fastDelivery": "توصيل سريع",
  "offers": "عروض",
  "openNow": "مفتوح الآن",
  "sortRelevance": "ترتيب: الأكثر ملاءمة",
  "sortDeliveryTime": "ترتيب: وقت التوصيل",
  "sortRating": "ترتيب: التقييم",
  "sortCostLowToHigh": "ترتيب: السعر من الأقل للأعلى",
  "sortCostHighToLow": "ترتيب: السعر من الأعلى للأقل",
  "noRestaurantsMatchFilters": "لا توجد مطاعم تطابق الفلاتر الخاصة بك",
  "clearFilters": "مسح الفلاتر",
  "noRestaurantsNearby": "لا توجد مطاعم متاحة في الجوار",
  "noRestaurantsNearbyDesc": "لم نتمكن من العثور على أي مطاعم بالقرب من موقعك الحالي في الوقت الحالي. حاول تغيير موقعك أو تحقق مرة أخرى بعد فترة.",
  "Filters & Sorting": "الفلاتر والترتيب",
  "quickFilters": "فلاتر سريعة",
  "fastDeliveryLimit": "توصيل سريع (أقل من ٣٠ دقيقة)",
  "offersBogoFree": "عروض (اشترِ واحدًا واحصل على الآخر مجانًا، توصيل مجاني)",
  "Pure Veg": "نباتي بالكامل",
  "Open Now": "مفتوح الآن",
  "newRestaurants": "مطاعم جديدة",
  "4.5+": "٤.٥+",
  "4.0+": "٤.٠+",
  "foodType": "نوع الطعام",
  "Veg": "نباتي",
  "Non-Veg": "غير نباتي",
  "Vegan": "نباتي صرف",
  "costRange": "فئة السعر",
  "Low (₹)": "منخفض (₹)",
  "Medium (₹₹)": "متوسط (₹₹)",
  "High (₹₹₹)": "مرتفع (₹₹)",
  "clearAll": "مسح الكل",
  "applyFilters": "تطبيق الفلاتر",
  "Relevance": "الأكثر ملاءمة",
  "Delivery Time": "وقت التوصيل",
  "Rating": "التقييم",
  "Cost Low to High": "السعر من الأقل للأعلى",
  "Cost High to Low": "السعر من الأعلى للأقل",
  "exclusiveDeals": "عروض حصرية",
  "todaysOffers": "عروض اليوم",
  "trendingThisWeek": "الأكثر رواجًا هذا الأسبوع",
  "whyChooseWaseeny": "لماذا تختار Waseeny؟",
  "fastestDelivery": "أسرع توصيل",
  "fastestDeliveryDesc": "احصل على طعامك في دقائق، طازجًا وساخنًا.",
  "securePayments": "مدفوعات آمنة",
  "securePaymentsDesc": "نقبل جميع بطاقات الائتمان الرئيسية وطرق الدفع عبر الإنترنت.",
  "qualityFood": "طعام عالي الجودة",
  "qualityFoodDesc": "نتعاون مع أفضل المطاعم لضمان الجودة.",
  "noTrendingRestaurants": "لم يتم العثور على مطاعم رائجة.",
  "dish": "طبق",
  "Please select or add a delivery address first.": "يرجى اختيار عنوان توصيل أو إضافته أولاً.",
  "Browse Restaurants": "تصفح المطاعم",
  "Please provide your delivery location details": "يرجى إدخال تفاصيل موقع التوصيل",
  "Back to Saved Addresses": "العودة إلى العناوين المحفوظة",
  "Please describe the reason": "يرجى وصف السبب",
  "all": "الكل",
  "whatOurCustomersSay": "ماذا يقول عملاؤنا",
  "forABetterExperience": "لتجربة أفضل",
  "downloadTheWaseenyApp": "حمّل تطبيق Waseeny",
  "getYourFoodDelivered": "احصل على طعامك بسرعة، وتتبّع طلبك مباشرة، واستمتع بعروض حصرية في التطبيق.",
  "Failed to cancel order": "تعذر إلغاء الطلب",
  "Chat with Rider": "الدردشة مع السائق",
  "Items": "الأصناف",
  "Refund Approved & Credited to Wallet": "تمت الموافقة على الاسترداد وإضافته إلى المحفظة",
  "Refund Request Submitted - Pending Admin Review": "تم تقديم طلب الاسترداد - بانتظار مراجعة الإدارة",
  "Something went wrong.": "حدث خطأ ما.",
  "Online card payment is unavailable until Stripe is configured. Please choose cash on delivery or contact support.": "الدفع بالبطاقة عبر الإنترنت غير متاح حاليًا. يرجى اختيار الدفع عند الاستلام أو التواصل مع الدعم.",
  "Card payment is unavailable until Stripe is configured.": "الدفع بالبطاقة غير متاح حاليًا.",
  "deliveryTime": "وقت التوصيل",
  "distance": "المسافة",
  "deliveryFee": "رسوم التوصيل",
  "supportContactMessage": "الدعم متاح على مدار الساعة. راسلنا على {email} أو اتصل على {phone}.",
  "exploreCollections": "استكشف المجموعات",
  "supportContactEmailOnly": "الدعم متاح على مدار الساعة. راسلنا على {email}.",
  "supportContactPhoneOnly": "الدعم متاح على مدار الساعة. اتصل بنا على {phone}.",
  "supportContactNone": "الدعم متاح على مدار الساعة. استخدم «تواصل مع الدعم» في ملفك الشخصي لمراسلتنا.",
  "Cuisines": "المطابخ",
  "outOfDeliveryArea": "عذرًا، لا نوصّل إلى هذا العنوان بعد.",
  "Delivery": "توصيل",
  "Pick-up": "استلام",
  "Pick up at": "الاستلام من",
  "Pay online now and show your pick-up code at the counter.": "ادفع الآن عبر الإنترنت واعرض رمز الاستلام عند الكاونتر.",
  "Pick-up orders are paid online.": "طلبات الاستلام تُدفع عبر الإنترنت.",
  "Could not change delivery option. Please try again.": "تعذر تغيير خيار التوصيل. حاول مرة أخرى.",
  "No longer available": "لم يعد متاحًا",
  "Your cart already has items. Replace them with this order?": "سلتك تحتوي على عناصر. هل تريد استبدالها بهذا الطلب؟",
  "Reorder": "إعادة الطلب",
  "Reordering...": "جارٍ إعادة الطلب...",
  "Remove this card?": "إزالة هذه البطاقة؟",
  "Saved cards": "البطاقات المحفوظة",
  "No saved cards yet.": "لا توجد بطاقات محفوظة بعد.",
  "Tick \"save card\" when you pay by card at checkout. Cards are stored securely by Stripe.": "اختر \"حفظ البطاقة\" عند الدفع. تُحفظ البطاقات بأمان لدى Stripe.",
  "Expires": "تنتهي",
  "Remove": "إزالة",
  "Allergens": "مسببات الحساسية",
  "No allergens declared - ask the restaurant if you have an allergy.": "لم يُصرَّح بمسببات حساسية - اسأل المطعم إذا كانت لديك حساسية.",
  "Download invoice (PDF)": "تنزيل الفاتورة (PDF)",
  "Downloading...": "جارٍ التنزيل...",
  "Could not download the invoice. Please try again.": "تعذر تنزيل الفاتورة. يرجى المحاولة مرة أخرى.",
  "Distance": "المسافة",
  "Within": "ضمن",
  "Cuisine": "المطبخ",
  "Any cuisine": "كل المطابخ",
  "Any distance": "أي مسافة",
  "Tip your rider": "إكرامية للسائق",
  "100% of the tip goes to your rider": "100% من الإكرامية تذهب إلى السائق",
  "Not now": "ليس الآن",
  "Could not update the tip. Please try again.": "تعذر تحديث الإكرامية. يرجى المحاولة مرة أخرى.",
  "Share this code with your delivery partner to receive your order": "شارك هذا الرمز مع مندوب التوصيل لاستلام طلبك",
};